/** Paleta do painel de prontuário na sessão de vídeo. */
export const PRONTUARIO_BG_CLASS = 'bg-[#121A24]';

/** Fundo do painel de transcrição ao vivo no prontuário — um pouco mais claro que o painel. */
export const PRONTUARIO_TRANSCRIPTION_BG_CLASS = 'bg-[#1a2430]';

/** Respiro inferior no scroll da transcrição (footer já ocupa espaço no layout). */
export const PRONTUARIO_TRANSCRIPTION_SCROLL_FOOTER_CLEARANCE_CLASS =
	'h-8 shrink-0';

/** Padding horizontal do header do prontuário. */
export const PRONTUARIO_HEADER_PADDING_X = 'px-2';

/** Padding horizontal padrão de cada bloco do painel. */
export const PRONTUARIO_PANEL_PADDING_X = 'px-3';

/** Padding da seção de anotações da sessão (um pouco menor que o painel). */
export const PRONTUARIO_NOTES_PADDING_X = 'px-5';

/** Superfície do cartão/campos do paciente — mesma família do painel (#121A24). */
export const PRONTUARIO_PATIENT_SURFACE_CLASS =
	'rounded-xl border border-white/[0.08] bg-[#1a2430]';

/** Cartão do paciente clicável (notas). */
export const PRONTUARIO_PATIENT_CARD_CLASS = `${PRONTUARIO_PATIENT_SURFACE_CLASS} transition-[background-color,transform] duration-200 ease-out hover:bg-[#1e2a34] active:scale-[0.995]`;

/** Divisor interno — usado no detalhe do perfil. */
export const PRONTUARIO_PATIENT_DIVIDER_CLASS = 'border-t border-white/[0.08]';

/** Label de metadados do cartão do paciente. */
export const PRONTUARIO_PATIENT_META_LABEL_CLASS =
	'text-[11px] font-medium uppercase tracking-[0.04em] text-slate-500';

/** Chip de evolução clínica no cartão do paciente. */
export const PRONTUARIO_PATIENT_TAG_CLASS =
	'inline-flex rounded-md bg-white/[0.06] px-2 py-0.5 text-[12px] font-medium leading-none text-slate-400';

/** Botão fantasma do header (sem borda). */
export const PRONTUARIO_GHOST_BUTTON_CLASS =
	'text-slate-400 transition-[color,background-color] duration-200 hover:bg-white/[0.06] hover:text-slate-200 active:bg-white/[0.09]';

/** Botão pilula do header (voltar + sessões). */
export const PRONTUARIO_PILL_BUTTON_CLASS =
	'rounded-full text-slate-400 transition-[color,background-color] duration-200 hover:bg-white/[0.06] hover:text-slate-200 active:bg-white/[0.09]';

/** Slot fixo dos ícones do header — mantém o voltar na mesma posição em todas as telas. */
export const PRONTUARIO_HEADER_ICON_SLOT_CLASS =
	'flex size-9 shrink-0 items-center justify-center';

/** Glow sutil ao redor do indicador de áudio/transcrição (após clique). */
export const PRONTUARIO_AUDIO_VISUALIZER_GLOW_CLASS =
	'shadow-[0_0_0_1px_rgba(138,180,248,0.1),0_0_12px_2px_rgba(138,180,248,0.16)]';

/** Item de lista sem borda (sessões). */
export const PRONTUARIO_LIST_ITEM_CLASS =
	'rounded-xl px-3 py-2.5 transition-colors hover:bg-white/[0.05]';

/** Título de telas do histórico de sessões (Material). */
export const PRONTUARIO_SESSIONS_TITLE_CLASS =
	'text-[22px] font-medium leading-tight tracking-[0.01em] text-[#e8eaed]';

/** Subtítulo de telas do histórico de sessões (Material). */
export const PRONTUARIO_SESSIONS_SUBTITLE_CLASS =
	'mt-1 text-[14px] leading-relaxed text-[#9aa0a6]';

/** Perfil do paciente — hero e listas (distinto do card de notas, mesma paleta). */
export const PRONTUARIO_PROFILE_CHIP_CLASS =
	'inline-flex items-center gap-1 rounded-full border border-white/[0.08] bg-[#1a2430] px-3 py-1.5 text-[13px] font-medium leading-none text-slate-200';

/** Tags de evolução clínica no hero do perfil. */
export const PRONTUARIO_PROFILE_TAG_CLASS = PRONTUARIO_PATIENT_TAG_CLASS;

export const PRONTUARIO_PROFILE_SECTION_TITLE_CLASS =
	'px-1 text-[11px] font-medium uppercase tracking-[0.04em] text-[#8ab4f8]/75';

export const PRONTUARIO_PROFILE_LIST_GROUP_CLASS =
	'overflow-hidden rounded-xl border border-white/[0.08] bg-[#1a2430] shadow-[0_1px_3px_rgba(0,0,0,0.25)]';

export const PRONTUARIO_PROFILE_LIST_LABEL_CLASS =
	'text-[12px] leading-none text-slate-500';

export const PRONTUARIO_PROFILE_LIST_VALUE_CLASS =
	'mt-1.5 text-[14px] leading-snug text-slate-200';

export const PRONTUARIO_PROFILE_AVATAR_CLASS =
	'flex shrink-0 items-center justify-center rounded-full bg-[#8ab4f8]/12 font-medium uppercase tracking-wide text-[#8ab4f8] ring-2 ring-[#8ab4f8]/30';

/** Título de seção no detalhe do paciente. */
export const PRONTUARIO_DETAIL_SECTION_TITLE_CLASS =
	'text-[13px] font-medium leading-tight text-slate-200';

/** Campo readonly em telas de detalhe (sessão passada, paciente). */
export const PRONTUARIO_SESSION_DETAIL_LABEL_CLASS =
	'text-[11px] font-medium uppercase tracking-[0.04em] text-slate-500';

export const PRONTUARIO_SESSION_DETAIL_VALUE_CLASS =
	'mt-1.5 rounded-lg border border-white/[0.08] bg-[#1a2430] px-3 py-2.5 text-[14px] leading-relaxed text-slate-200';

/** Tag sem borda — só fundo suave. */
export const PRONTUARIO_TAG_CLASS =
	'rounded-md bg-white/[0.08] px-1.5 py-px text-[11px] font-medium leading-tight text-slate-300';

/** Campo de anotações — canvas transparente como no Notion. */
export const PRONTUARIO_NOTES_INPUT_CLASS =
	'w-full resize-none border-0 bg-transparent px-0 py-0 text-[15px] leading-[1.65] text-slate-200 outline-none ring-0 placeholder:text-slate-600 focus:ring-0';

/** Scroll interno do painel de perfil (conteúdo dos accordions). */
export const PRONTUARIO_PANEL_SCROLL_CLASS =
	'overflow-y-auto overscroll-contain scroll-smooth [scrollbar-gutter:stable] [scrollbar-width:thin] [scrollbar-color:rgba(255,255,255,0.2)_transparent] [&::-webkit-scrollbar]:w-1.5 [&::-webkit-scrollbar-track]:bg-transparent [&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb]:bg-white/20 hover:[&::-webkit-scrollbar-thumb]:bg-white/30';

/** Transição horizontal entre telas do prontuário na videochamada. */
export const PRONTUARIO_VIEW_TRANSITION_MS = 360;

/** Duração (em segundos) usada pelo motor de transição em framer-motion. */
export const PRONTUARIO_VIEW_TRANSITION_SEC =
	PRONTUARIO_VIEW_TRANSITION_MS / 1000;

/** Curva da casa — mesma usada no slide do modal da dashboard. */
export const PRONTUARIO_VIEW_TRANSITION_EASE = [0.32, 0.72, 0, 1] as const;
